import type {
  ColumnDef,
  DataRow,
  TableFilterValues,
} from "@kontextwerk/web-sdk/ui/layout/Table.svelte"

export type OrderTypeRow = DataRow & {
  typeLabel: string
  internalLabel: string
  publicLabel: string
  durationLabel: string
  description: string
  orderType: OrderType
}

export const orderTypeColumns: ColumnDef[] = [
  {
    id: "typeLabel",
    label: "Typ",
    isPrimary: true,
    tooltip: "Öffentliche und interne Bezeichnung des Auftragstyps.",
    sortable: true,
    sortKey: "typeLabel",
    sortType: "text",
    getSortValue: (row) => (row as OrderTypeRow).publicLabel,
  },
  {
    id: "durationLabel",
    label: "Dauer",
    tooltip: "Standarddauer in Minuten, die zur Terminplanung genutzt wird.",
    sortable: true,
    sortKey: "durationLabel",
    sortType: "number",
    defaultSortDir: "desc",
    getSortValue: (row) => (row as OrderTypeRow).orderType.typical_duration_min ?? -1,
  },
  {
    id: "description",
    label: "Beschreibung",
    tooltip:
      "Aufforderungsbeschreibung, die Kundinnen und Kunden in Portal, E-Mail und Briefen sehen.",
    sortable: true,
    sortKey: "description",
    sortType: "text",
  },
]

export const orderTypeFilter = {
  column: "typeLabel",
  type: "text",
  label: "Bezeichnung",
  placeholder: "Nach Auftragstyp filtern…",
}

const sortOrderTypes = (types: OrderType[]) =>
  [...types].sort((a, b) =>
    a.internal_label.localeCompare(b.internal_label, "de", { sensitivity: "base" }),
  )

const formatDuration = (value: number | null | undefined) =>
  value !== null && value !== undefined ? `${value} min` : "–"

export const toOrderTypeRows = (types: OrderType[]): OrderTypeRow[] =>
  sortOrderTypes(types).map((type) => ({
    id: type.id,
    typeLabel: type.public_label,
    internalLabel: type.internal_label,
    publicLabel: type.public_label,
    durationLabel: formatDuration(type.typical_duration_min),
    description: type.description || "–",
    orderType: type,
  }))

export const filterOrderTypeRows = (
  rows: OrderTypeRow[],
  filters: TableFilterValues | null | undefined,
): OrderTypeRow[] => {
  const query = (filters?.typeLabel ?? "").toString().toLowerCase().trim()

  return query
    ? rows.filter((row) =>
        [row.internalLabel, row.publicLabel].some((value) => value.toLowerCase().includes(query)),
      )
    : rows
}
